import mellConfig from "./mell/index.js"
import argenConfig from "./argen/index.js"

export const TEMPLATES = [
  {
    key: "mell",
    name: "Mell",
    description: "Современный шаблон для сайтов",
  },
  {
    key: "argen",
    name: "Argen",
    description: "Imperium шаблон",
  },
]

export const DEFAULT_TEMPLATE_KEY = "mell"
const TEMPLATE_CONFIGS = {
  mell: mellConfig,
  argen: argenConfig,
}

/**
 * Возвращает конфигурацию шаблона по ключу.
 * При неизвестном ключе или null/undefined возвращает конфиг mell (fallback).
 * @param {string | null | undefined} templateKey
 * @returns {import("./mell/index.js").mellConfig} Конфиг шаблона. Может включать поле
 * `bannerImageConstraints`: либо `{ width, height }`, либо `{ variants: [{ width, height }, ...] }`
 * для нескольких допустимых соотношений сторон баннера.
 */
export function getTemplateConfig(templateKey) {
  if (templateKey && TEMPLATE_CONFIGS[templateKey]) {
    return TEMPLATE_CONFIGS[templateKey]
  }
  return TEMPLATE_CONFIGS[DEFAULT_TEMPLATE_KEY]
}
